import * as React from 'react';

import { createIcon } from '../icon';

export const TilesPure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g fill="currentColor" fillRule="evenodd">
      <rect width="6" height="6" rx=".5" />
      <rect width="6" height="6" y="8" rx=".5" />
      <rect width="6" height="6" x="8" y="8" rx=".5" />
      <rect width="6" height="6" x="8" rx=".5" />
    </g>
  </svg>,
);

export const TilesIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <TilesPure className={props.iconClassName} />
);

TilesIcon.displayName = 'TilesIcon';
